<template>
  <el-main class="common-main">
    <div class="container">
      <el-row class="tac" :gutter="20">
        <el-col :span="4">
          <TheLeft></TheLeft>
        </el-col>
        <el-col :span="20">
          <div class="user-list user-header" @click="openUser">
            <div class="user-list-left">
              <el-avatar :src="user.avatar" :size="80"></el-avatar>
              <div class="user-info">
                <div class="user-title">
                  {{ user.username || user.phone }}
                </div>
                <div class="user-identity">
                  <el-tag effect="plain" size="mini" type="danger" v-if="identityError">
                    未进行实名认证
                  </el-tag>
                  <el-tag effect="plain" size="mini" type="info" v-if="identity && identity.status === 0">
                    实名审核中...
                  </el-tag>
                  <el-tag effect="plain" size="mini" type="success" v-if="identity && identity.status === 1">
                    实名认证
                  </el-tag>
                  <el-tag effect="plain" size="mini" type="warning" v-if="identity && identity.status === 2">
                    实名认证失败
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="el-icon-arrow-right"></div>
          </div>
          <div class="user-content">
            <div class="user-list border-bottom" @click="openPassword">
              <div class="user-list-left">
                <span class="el-icon-key"></span>
                <span>修改密码</span>
              </div>
              <div class="el-icon-arrow-right"></div>
            </div>
            <div class="user-list" @click="openIdCard">
              <div class="user-list-left">
                <span class="el-icon-postcard"></span>
                <span>实名认证</span>
              </div>
              <div class="el-icon-arrow-right"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-drawer title="个人信息" :visible.sync="drawerUser" direction="rtl">
      <div class="user-drawer">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" label-position="left">
          <el-form-item label="头像" prop="avatar">
            <el-upload
                class="avatar-uploader"
                action="https://xcx.yxyuanxue.com/api/v1/images"
                :show-file-list="false"
                accept="image/*"
                name="image"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.avatar" :src="ruleForm.avatar" class="avatar" alt="头像"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="昵称" prop="username">
            <el-input v-model="ruleForm.username"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="ruleForm.gender">
              <el-radio-button :label="0">保密</el-radio-button>
              <el-radio-button :label="1">男</el-radio-button>
              <el-radio-button :label="2">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" v-loading.fullscreen.lock="fullscreenLoading">保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="修改密码" :visible.sync="drawerPassword" direction="rtl">
      <div class="user-drawer">
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="80px"
                 label-position="left">
          <el-form-item label="原密码" prop="password">
            <el-input v-model="passwordForm.password" type="password"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password">
            <el-input v-model="passwordForm.new_password" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="check_password">
            <el-input v-model="passwordForm.check_password" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitPassForm('passwordForm')"
                       v-loading.fullscreen.lock="fullscreenLoading">提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="实名认证" :visible.sync="drawerIdCard" direction="rtl">
      <div class="user-drawer">
        <el-form :model="IdCardForm" :rules="IdCardRules" ref="IdCardForm" label-width="80px"
                 label-position="left">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="IdCardForm.name" :disabled="!identityError && identity.status < 2"></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="idcard">
            <el-input v-model="IdCardForm.idcard" :disabled="!identityError && identity.status < 2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitIdCardForm('IdCardForm')"
                       v-loading.fullscreen.lock="fullscreenLoading" v-if="identityError">提交审核
            </el-button>
            <el-button type="primary" @click="submitIdCardUpdateForm('IdCardForm')"
                       v-loading.fullscreen.lock="fullscreenLoading" v-if="identity && identity.status === 2">重新提交审核
            </el-button>
            <el-button v-if="identity && identity.status === 1" type="success">您已完成实名认证</el-button>
            <el-button v-if="identity && identity.status === 0" type="info">您的实名资料正在审核中</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </el-main>
</template>

<script>
import TheLeft from "@/components/layouts/TheLeft";
import {mapGetters} from "vuex";
import {authRequest} from "@/utils/request";

export default {
  name: "userIndex",
  head: {
    title: "个人中心"
  },
  components: {
    TheLeft
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.new_password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      identity: '',
      identityError: '',
      drawerUser: false,
      ruleForm: {
        username: '',
        gender: '',
        avatar: ''
      },
      rules: {
        username: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
          {min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur'}
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ]
      },
      path: process.env.VUE_APP_FILE,
      fullscreenLoading: false,
      drawerPassword: false,
      passwordForm: {
        password: '',
        new_password: '',
        check_password: ''

      },
      passwordRules: {
        password: [
          {required: true, message: '请输入原密码', trigger: 'blur'},
          {min: 6, message: '最少6个字符', trigger: 'blur'}
        ],
        new_password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {min: 6, message: '最少6个字符', trigger: 'blur'}
        ],
        check_password: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      },
      drawerIdCard: false,
      IdCardForm: {
        name: '',
        idcard: ''
      },
      IdCardRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {min: 2, message: '最少2个字符', trigger: 'blur'}
        ],
        idcard: [
          {required: true, message: '请输入身份证号码', trigger: 'blur'},
          {min: 18, message: '最少18个字符', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  created() {
    this.getIdentity()
  },
  methods: {
    async getIdentity() {
      try {
        let response = await authRequest('user/identification', {
          method: 'GET'
        })
        this.identity = response.data.data
      } catch (e) {
        this.identityError = '未实名认证'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true
          try {
            let response = await authRequest('user', {
              method: 'PUT',
              params: this.ruleForm
            })
            if (response.status === 200) {
              this.$store.dispatch('getUser')
              this.drawerUser = false
              this.fullscreenLoading = false
              this.$message.success('保存成功')
            }
          } catch (e) {

          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    openUser() {
      this.ruleForm.username = this.user.username
      this.ruleForm.gender = this.user.gender
      this.ruleForm.avatar = this.user.avatar
      this.drawerUser = true
    },
    handleAvatarSuccess(res, file) {
      if (file.status === 'success') {
        this.$message.success('上传成功')
      }
      this.ruleForm.avatar = this.path + res
    },
    beforeAvatarUpload(file) {
      const result = file.size / 1024 / 1024 < 2;
      if (!result) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return result;
    },
    openPassword() {
      this.drawerPassword = true
    },
    submitPassForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true
          try {
            let response = await authRequest('user/pass', {
              method: 'POST',
              data: {
                password: this.passwordForm.password,
                new_password: this.passwordForm.new_password
              }
            })
            if (response.status === 200) {
              this.drawerPassword = false
              this.fullscreenLoading = false
              this.$message.success('修改成功')
            }
          } catch (e) {
            this.fullscreenLoading = false
          }
          this.$refs[formName].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitIdCardForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true
          try {
            let response = await authRequest('identification', {
              method: 'POST',
              data: this.IdCardForm
            })
            if (response.status === 201) {
              this.drawerIdCard = false
              this.fullscreenLoading = false
              this.$message.success('申请已提交')
              this.getIdentity()
            }
          } catch (e) {
            this.fullscreenLoading = false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitIdCardUpdateForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true
          try {
            let response = await authRequest('identification', {
              method: 'PUT',
              data: this.IdCardForm
            })
            if (response.status === 200) {
              this.drawerIdCard = false
              this.fullscreenLoading = false
              this.$message.success('申请已重新提交')
              this.getIdentity()
            }
          } catch (e) {
            this.fullscreenLoading = false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    openIdCard() {
      if (this.identity) {
        this.IdCardForm.name = this.identity.name
        this.IdCardForm.idcard = this.identity.idcard
      }
      this.drawerIdCard = true
    }
  }
}
</script>

<style scoped>
.user-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  cursor: pointer;
}

.user-header {
  background-color: #ffffff;
  padding: 10px 20px;
  height: 120px;
}

.user-list .el-icon-arrow-right {
  color: #6e6e6e;
}

.user-list-left {
  display: flex;
  align-items: center;
}

.user-info {
  margin-left: 30px;
}

.user-title {
  font-size: 18px;
}

.user-identity {
  margin-top: 10px;
}

.user-content {
  background-color: #ffffff;
  margin-top: 20px;
  padding: 0 20px;
}

.border-bottom {
  border-bottom: 1px dashed #ebebeb;
}

.user-list-left .el-icon-key {
  color: #de3e73;
  margin-right: 10px;
}

.user-list-left .el-icon-postcard {
  color: #08b108;
  margin-right: 10px;
}

.user-drawer {
  padding: 0 20px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #2aacb2;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>